import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AlbumDownloadDTO } from '../../../../shared/album-download-dto';

@Injectable({
  providedIn: 'root'
})
export class DownloadService {

  constructor(private http: HttpClient) { }

  getAlbumDownloads(albumId: number): Observable<AlbumDownloadDTO> {
    return this.http.get(`/api/album/${albumId}/download`) as Observable<AlbumDownloadDTO>
  }

  getBonusDownloads(): Observable<any> {
    return this.http.get(`/api/album/bonus`) as Observable<any>
  }

  recordDownload(downloadId: number, albumId: number, albumMediaId: number , orderId: number): Observable<any> {
    return this.http.post(`/api/downloadLog`, { downloadId, albumId, albumMediaId, orderId }) as Observable<any>
  }

  redeemIheartvinyl(code: string, email?: string): Observable<AlbumDownloadDTO> {
    return this.http.post<AlbumDownloadDTO>(`/api/code-batch/redeem/${code}`, { email })
  }

  recordIheartvinyl(code: string) {
    return this.http.post(`/api/code-batch/download/${code}`, { action: 'download' })
  }
}
